import "./index.scss";
import { Badge } from "@wise-emotions/react-badge";
import { Button, ButtonLink } from "@wise-emotions/react-button";
import {
  GeneralSmallChevronDown,
  GeneralSmallChevronUp,
} from "@wise-emotions/react-icons";
import { Poly } from "components/Poly";
import { PolyAnchor } from "components/Anchor/utils";
import OfferDetailItem, {
  Props as OfferDetail,
} from "components/Cards/CardOfferNew/Components/OfferDetailItem";
import React from "react";
import cn from "classnames";

type Props = {
  title: string;
  price?: string;
  priceDetail?: string;
  ctaLabel?: string;
  badgeLabel?: string;
  showMoreLabel: string;
  detailList: OfferDetail[];
  isMobileFullShown?: boolean;
  variant?: "dark" | "light";
} & PolyAnchor;

export const CardOffer = ({
  ctaLabel,
  showMoreLabel,
  price,
  priceDetail,
  detailList,
  title,
  variant = "dark",
  badgeLabel,
  isMobileFullShown = false,
  ...props
}: Props) => {
  const [isAccordionOpen, setIsAccordionOpen] = React.useState(false);

  return (
    <div
      className={cn("card-offer", {
        "card-offer--light": variant === "light",
        "elevation-card": props.as,
      })}
    >
      <div className={cn("card-offer__top")}>
        {badgeLabel && (
          <div className="card-offer__top__badge">
            <Badge
              variant="onlyLabel"
              theme="brand"
              contrast="high-contrast"
              label={badgeLabel}
            />
          </div>
        )}
        <h4 className="card-offer__top__title">{title}</h4>
        {price && <h2 className="card-offer__top__price">{price}</h2>}
        {priceDetail && (
          <p className="card-offer__top__price-detail">{priceDetail}</p>
        )}
        {ctaLabel && (
          <Poly {...props}>
            <Button
              variant="default"
              theme={variant === "dark" ? "primary" : "secondary"}
            >
              {ctaLabel}
            </Button>
          </Poly>
        )}
      </div>
      <div className="card-offer__bottom">
        {detailList.map((detail, i) => (
          <div
            className={cn("card-offer__bottom__item", {
              "card-offer__bottom__item--mobile-visible":
                !isMobileFullShown && i > 1 && isAccordionOpen,
              "card-offer__bottom__item--mobile-hidden":
                !isMobileFullShown && i > 1 && !isAccordionOpen,
            })}
            key={variant}
          >
            <OfferDetailItem {...detail} />
          </div>
        ))}
        {!isMobileFullShown && (
          <div className="card-offer__bottom__accordion-cta">
            <ButtonLink
              variant="rightIcon"
              Icon={
                isAccordionOpen
                  ? GeneralSmallChevronUp
                  : GeneralSmallChevronDown
              }
              text={showMoreLabel}
              onClick={() => setIsAccordionOpen((oldValue) => !oldValue)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

CardOffer.displayName = "CardOffer";
